import { inject, Injectable } from '@angular/core';
import { InitStore } from '@app2/store/init/init.store';
import { Store } from '@ngrx/store';
import { sessionSelectors } from '@store/session';

@Injectable()
export class AppFacade {

  private store = inject(InitStore);

  private globalStore = inject(Store);

  isUserAdult$ = this.store.isUserAdult;

  isUserSetAdult$ = this.store.isUserSetAdult;

  pendingAuthDialog$ = this.store.pendingAuthDialog;

  isUserSet = this.globalStore.selectSignal(sessionSelectors.selectIsSetUser);
}